;(function () {
  angular.module('contrast.permissions').factory('permissions', permissions)

  function permissions(
    $log,
    $rootScope,
    $q,
    $window,
    $translate,
    amMoment,
    UserFactory,
    GlobalFactory,
    ProfileFactory,
    GlobalService,
    UserService,
    ProfileService,
    FeaturesService,
    ErrorService,
    AuthService,
    onboardingSetupService,
    pendoService,
    featureFlags,
    ServiceUtils,
    DEPLOYMENT_MODE,
    SYSTEM_ROLES,
    PROTECTION_EVENTS,
    $routeParams
  ) {
    'ngInject'

    var main = [
      'ADMIN',
      'RULES_ADMIN',
      'EDIT',
      'VIEW',
      'SUPERADMIN',
      'SERVER_ADMIN',
      'SYSTEM_ADMIN',
      'OBSERVER'
    ]

    var impersonating = false,
      toggleEnabled = false,
      adminRole = '',
      permissionList = [],
      resourceActionMap = {},
      appPermissions = [],
      loadUserAccessPromise,
      blockSuperAdmin = false,
      properties = null,
      propertiesPromise = null,
      userHasSastProjectCreatePermission = false,
      userHasRbacAttackEventsViewPermission = false,
      userHasRbacManagePermission = false

    init()

    const UserPreferenceStorageKey = {
      language: 'userPrefLanguage',
      dateFormat: 'userPrefDateFormat',
      timeFormat: 'userPrefTimeFormat',
      timeZone: 'userPrefTimeZone'
    }

    return {
      getMostPermissiveRole: getMostPermissiveRole,
      setPermissions: setPermissions,
      setResourceActions: setResourceActions,
      hasPermission: hasPermission,
      hasResourcePermission: hasResourcePermission,
      maxPermission: maxPermission,
      hasEnterprisePermission: hasEnterprisePermission,
      hasAnyPermission: hasAnyPermission,
      hasAllPermission: hasAllPermission,
      hasAppPermission: hasAppPermission,
      hasPermissionToApps: hasPermissionToApps,
      updateAppPermissions: updateAppPermissions,

      isImpersonating: isImpersonating,
      isToggleEnabled: isToggleEnabled,
      getAdminRole: getAdminRole,

      isRASPEnabled: isRASPEnabled,
      isServerlessEnabled: isServerlessEnabled,
      isFreemium: isFreemium,
      showSetupHeader: showSetupHeader,

      isSaaS: isSaaS,
      isEOP: isEOP,

      loadUserSettings: loadUserSettings,
      getUserAccessLoaded: getUserAccessLoaded,
      getProperties: getProperties,
      getLoadedProperties: getLoadedProperties,
      getAuthSettings: getAuthSettings,
      getUser: getUser,
      getRoles: getRoles,
      getUserActions: getUserActions,
      getUserAccess: getUserAccess,
      getDefaultOrganization: getDefaultOrganization,
      getOrganization: getOrganization,
      getAllowedOrganizations: getAllowedOrganizations,
      getUserPreferences: getUserPreferences,
      getSetupSteps: getSetupSteps,
      model: {
        breakdown: {
          ONBOARDING: 'COMPLETE',
          VULNERABILITIES: 'INACTIVE',
          LIBRARIES: 'INACTIVE',
          EXERCISE_APP: 'ACTIVE',
          ATTACKS: 'ACTIVE'
        }
      },
      getPermissions: getPermissions,
      isRbacNewSensorButtonEnabled: isRbacNewSensorButtonEnabled,
      isAttackEventsViewEnabled: isAttackEventsViewEnabled,
      setRbacAttackEventsViewPermission: setRbacAttackEventsViewPermission,
      setRbacManagePermission: setRbacManagePermission,
      hasRbacManagePermission: hasRbacManagePermission,
      setSastProjectCreatePermission: setSastProjectCreatePermission,
      addSastProjectCreatePermissionToResourceActionMap:
        addSastProjectCreatePermissionToResourceActionMap
    }

    //TODO extract this method a new service
    function init() {
      if (AuthService.isAuthenticated()) {
        loadUserSettings(true)
      }
    }

    function loadUserSettings(loadUser) {
      $rootScope.allowed_organizations = []
      return getAllowedOrganizations()
        .then(function () {
          var promises = []
          promises.push(getNewUserOnboardingPreference())
          promises.push(getNewUserNotificationPreference())
          promises.push(getProperties())
          promises.push(getRoles())
          promises.push(getAuthSettings())
          if (loadUser) {
            promises.push(getUser())
          }
          return $q
            .all(promises)
            .then(function () {
              if (
                $rootScope.allowed_organizations &&
                $rootScope.allowed_organizations.length === 0
              ) {
                if (blockSuperAdmin) {
                  return $q.reject({ blockSuperAdmin: true })
                }
              }
              if (angular.isUndefined(SYSTEM_ROLES[adminRole])) {
                if ($routeParams.orgUuid) {
                  return getOrganization()
                } else {
                  return getDefaultOrganization()
                }
              }
            })
            .catch(function (response) {
              $log.error('Login Error', response)
              ErrorService.processError(response)
            })
        })
        .catch(function (response) {
          $log.error('get allowed orgs failed: ', response)
          return $q.reject(response)
        })
    }

    function getProperties() {
      return GlobalFactory.getTeamServerProperties().then(
        function (response) {
          GlobalService.setProperties(response.data)
          $rootScope.$broadcast('teamserverproperties.update', {})
          return response.data
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getLoadedProperties() {
      var deferred = $q.defer()

      if (properties) {
        deferred.resolve(properties)
      } else if (propertiesPromise != null) {
        propertiesPromise.then(function (props) {
          deferred.resolve(properties)
          return props
        })
      } else {
        propertiesPromise = getProperties().then(function (data) {
          properties = data
          deferred.resolve(properties)
          return properties
        })
      }

      return deferred.promise
    }

    function setUserProfile(profile) {
      ProfileService.setUser(profile)

      const nonSpanishLanguage =
        profile.preferences.language !== 'es'
          ? profile.preferences.language
          : 'en'

      //update language
      $translate.use(nonSpanishLanguage)

      // Update moment.js locale (valid values: en, es, ja)
      amMoment.changeLocale(nonSpanishLanguage)

      $rootScope.$broadcast('profile:loaded', {})
    }

    function getUser() {
      return ProfileFactory.getProfile(
        'preferences,email,ip_address,free_trial'
      )
        .then(function (response) {
          const user = response.data.user

          // TS-9051 Workaround - Update the locale storage to contain user data
          $window.localStorage.setItem(
            UserPreferenceStorageKey.language !== 'es'
              ? UserPreferenceStorageKey.language
              : 'en',
            user.preferences.language
          )
          $window.localStorage.setItem(
            UserPreferenceStorageKey.dateFormat,
            user.preferences.date_format
          )
          $window.localStorage.setItem(
            UserPreferenceStorageKey.timeFormat,
            user.preferences.time_format
          )
          $window.localStorage.setItem(
            UserPreferenceStorageKey.timeZone,
            user.preferences.time_zone
          )

          setUserProfile(user)
        })
        .catch((e) => {
          ErrorService.processError(e)

          // TS-9051 Workaround - Build user profile preferences based off cached last known preferences
          const profile = {
            preferences: {
              language: $window.localStorage.getItem(
                UserPreferenceStorageKey.language !== 'es'
                  ? UserPreferenceStorageKey.language
                  : 'en'
              ),
              date_format: $window.localStorage.getItem(
                UserPreferenceStorageKey.dateFormat
              ),
              time_format: $window.localStorage.getItem(
                UserPreferenceStorageKey.timeFormat
              ),
              time_zone: $window.localStorage.getItem(
                UserPreferenceStorageKey.timeZone
              )
            }
          }

          setUserProfile(profile)
        })
    }

    function getUserAccess(breakCache) {
      if (breakCache || !loadUserAccessPromise) {
        loadUserAccessPromise = UserFactory.getRASPAccess()
          .then(function (response) {
            ProfileService.setServerlessEnabled(response.data)
            ProfileService.setRASPEnabled(response.data)
            $rootScope.$broadcast(PROTECTION_EVENTS.STATE_UPDATED)
          })
          .catch(ErrorService.processError)
      }
      return loadUserAccessPromise
    }

    function getUserAccessLoaded() {
      return loadUserAccessPromise
    }

    function getAuthSettings() {
      return GlobalFactory.getAuthSettings()
        .then(function (response) {
          var data = response.data
          GlobalService.setAttributeLabel(data.user_attribute)
          GlobalService.setManagingUsers(data.managing_users)
          $rootScope.$broadcast('isManagingUsers:loaded', {})
        })
        .catch(ErrorService.processError)
    }

    function getDefaultOrganization() {
      return ProfileFactory.getDefaultOrganization()
        .then(function (response) {
          var data = response.data.organization
          UserService.setCurrentOrganization(data)
          UserService.setEnterprise(response.data.enterprise)
          pendoService.initialize(
            ProfileService.getUser(),
            UserService.getCurrentOrganization()
          )

          return getUserPreferences()
        })
        .catch(ServiceUtils.handleError)
    }

    function getOrganization() {
      return ProfileFactory.getOrganization($routeParams.orgUuid)
        .then(function (response) {
          var data = response.data.organization
          UserService.setCurrentOrganization(data)
          UserService.setEnterprise(response.data.enterprise)
          pendoService.initialize(
            ProfileService.getUser(),
            UserService.getCurrentOrganization()
          )

          return getUserPreferences()
        })
        .catch(ServiceUtils.handleError)
    }

    function getUserPreferences() {
      if (isFreemium()) {
        var promises = []
        promises.push(_getSetupInformation())

        return $q.all(promises).then(function (results) {
          UserService.setUserPreferences(results[0].steps)
          $rootScope.$broadcast('setups:loaded', {})
        })
      } else {
        return $q.when()
      }
    }

    function _getSetupInformation() {
      return onboardingSetupService.getSetupSteps()
    }

    function getAllowedOrganizations() {
      return ProfileFactory.getAllowedOrganizations()
        .then(function (response) {
          var data = response.data
          $rootScope.allowed_organizations = data.organizations
          $rootScope.$broadcast('roles:loaded', {})
        })
        .catch(ErrorService.processError)
    }

    function getRoles() {
      return ProfileFactory.getRoles().then(
        function (response) {
          var data = response.data
          impersonating = data.impersonating
          toggleEnabled = data.toggleEnabled
          adminRole = data.adminRole
          blockSuperAdmin = data.blockSuperAdmin
          $rootScope.$broadcast('roles:loaded', {})
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function getUserActions() {
      if ($routeParams.orgUuid) {
        return ProfileFactory.getUserActions($routeParams.orgUuid)
          .then(function (response) {
            return {
              actions: response.data.ORG_SETTINGS || [],
              resourceAccessObj: response.data
            }
          })
          .catch(function (err) {
            ErrorService.processError(err)
            return {
              actions: [],
              resourceAccessObj: []
            }
          })
      }
    }

    function getNewUserOnboardingPreference() {
      return UserFactory.getNewUserOnboardingPreference().then(function (
        response
      ) {
        ProfileService.setNewUserOnboardingPreference(response.data.new_user)
      },
      ErrorService.processError)
    }

    function getNewUserNotificationPreference() {
      return UserFactory.getNewUserNotificationPreference().then(function (
        response
      ) {
        ProfileService.setNewUserNotificationPreference(
          response.data.new_user_notification
        )
      },
      ErrorService.processError)
    }

    function getMostPermissiveRole() {
      var rbacStatus = FeaturesService.getRbacStatus()
      var isRbacEnforced = rbacStatus.enabled && rbacStatus.isAssessEnforced
      var currentRoles = permissionList.map(function (role) {
        return isRbacEnforced ? role : role.substring(5) // remove "ROLE_" string from permission list
      })

      for (var i = 0; i < main.length; i++) {
        var role = main[i]
        if (currentRoles.indexOf(role) !== -1) {
          return role
        }
      }
      return undefined
    }

    function setPermissions(permissions) {
      permissionList = permissions
      $rootScope.$broadcast('permissions:updated')
    }

    function setResourceActions(resourceAccessObj) {
      resourceActionMap = resourceAccessObj
      $rootScope.$broadcast('resourceActions:updated')
    }

    function hasPermission(permission) {
      permission = prefixPermissionName(permission)
      return _.some(permissionList, function (item) {
        if (_.isString(item)) {
          return item.trim() === permission
        }
      })
    }

    function hasResourcePermission(resourceType, permission) {
      if (resourceActionMap[resourceType]) {
        return resourceActionMap[resourceType].includes(permission)
      }
      return false
    }

    function addSastProjectCreatePermissionToResourceActionMap(resourceMap) {
      if (resourceMap === undefined) {
        resourceMap = []
      }

      if (userHasSastProjectCreatePermission) {
        if (resourceMap['RESOURCE_GROUP'] === undefined) {
          resourceMap['RESOURCE_GROUP'] = []
        }
        resourceMap['RESOURCE_GROUP'].push('RESOURCE_GROUP_PROJECT_CREATE')
      }
      return resourceMap
    }

    function getPermissions() {
      return permissionList
    }

    function maxPermission(permission) {
      permission = prefixPermissionName(permission)

      return _.indexOf(permissionList, permission) === 0
    }

    function hasEnterprisePermission(permission) {
      return UserService.isEnterprise() && hasPermission(permission)
    }

    function hasAllPermission(permissions) {
      var listPermission = permissions.split(',')
      return _.every(listPermission, function (item) {
        item = prefixPermissionName(item)
        return _.some(permissionList, function (perm) {
          if (_.isString(perm)) {
            return perm.trim() === item
          }
        })
      })
    }

    function hasAnyPermission(permissions) {
      var listPermission = permissions.split(',')
      return _.some(listPermission, function (item) {
        item = prefixPermissionName(item)
        return _.some(permissionList, function (perm) {
          if (_.isString(perm)) {
            return perm.trim() === item
          }
        })
      })
    }

    function hasAppPermission(application, permission) {
      permission = prefixPermissionName(permission)

      var roles = appPermissions[application]

      return _.some(roles, function (item) {
        if (_.isString(item)) {
          return item.trim() === permission
        }
      })
    }

    function hasPermissionToApps(apps, permission) {
      permission = prefixPermissionName(permission)

      if (apps.length > 0) {
        return apps.every(function (app) {
          return app.allowed_roles.includes(permission)
        })
      }
      return false
    }

    function isImpersonating() {
      return impersonating
    }

    function isToggleEnabled() {
      return toggleEnabled
    }

    function getAdminRole() {
      return adminRole
    }

    function isRASPEnabled() {
      const isRaspEnabled =
        UserService.isOrganizationProtectionEnabled() && // org level
        featureFlags.isOn('rasp') // global level, deprecated

      if (!isRaspEnabled) {
        return false
      }

      if (isRbacEnabledAssessEnforced()) {
        return hasResourcePermission('APPLICATION', 'PROTECT_ACCESS')
      }
      return ProfileService.isRASPEnabled() // user level
    }

    function isServerlessEnabled() {
      const isServerlessActive =
        ProfileService.isServerlessEnabled() && featureFlags.isOn('cloudnative')

      if (isRbacEnabledAssessEnforced()) {
        return (
          isServerlessActive &&
          hasResourcePermission('FUNCTION', 'ACCESS_SERVERLESS')
        )
      }

      return isServerlessActive
    }

    function updateAppPermissions(application, permissions) {
      appPermissions[application] = removeRolePrefixIfRbacEnabled(permissions)
      $rootScope.$broadcast('apppermissions:updated')
    }

    function removeRolePrefixIfRbacEnabled(permissions) {
      return isRbacEnabledAssessEnforced()
        ? permissions.map((permission) => permission.replace('ROLE_', ''))
        : permissions
    }

    function isRbacEnabledAssessEnforced() {
      const rbacStatus = FeaturesService.getRbacStatus()
      return rbacStatus.enabled && rbacStatus.isAssessEnforced
    }

    function isEOP() {
      return GlobalService.getMode() === DEPLOYMENT_MODE.PROD
    }

    function isSaaS() {
      return GlobalService.getMode() === DEPLOYMENT_MODE.SAAS
    }

    function isFreemium() {
      return UserService.isFreemiumOrganization()
    }

    function showSetupHeader() {
      return UserService.isFreemiumOrganization()
    }

    function getSetupSteps() {
      return UserService.getSetupSteps()
    }

    function prefixPermissionName(permission) {
      if (isRbacEnabledAssessEnforced()) {
        return permission.trim()
      } else {
        return 'ROLE_' + permission.trim()
      }
    }

    function isRbacNewSensorButtonEnabled() {
      const rbacStatus = FeaturesService.getRbacStatus()
      return (
        rbacStatus.enabled &&
        (hasSastProjectCreatePermission(rbacStatus) ||
          hasEditOrgSettings(rbacStatus))
      )
    }

    function hasEditOrgSettings(rbacStatus) {
      return (
        rbacStatus.isAssessEnforced &&
        hasResourcePermission('ORG_SETTINGS', 'EDIT')
      )
    }

    function hasSastProjectCreatePermission(rbacStatus) {
      return rbacStatus.isScanEnforced && userHasSastProjectCreatePermission
    }

    // this call is for the current user
    function setSastProjectCreatePermission() {
      const orgUuid = $routeParams.orgUuid
      if (!orgUuid) {
        userHasSastProjectCreatePermission = false
        return
      }

      const getResourceGroupsByAction =
        ProfileFactory.getResourceGroupsByAction(
          orgUuid,
          'RESOURCE_GROUP_PROJECT_CREATE'
        )
          .then(function (response) {
            return {
              allowed:
                Array.isArray(response.data.accessList) &&
                response.data.accessList.length > 0
            }
          })
          .catch(function (err) {
            ErrorService.processError(err)
            return {
              allowed: false
            }
          })
      getResourceGroupsByAction
        .then(function (response) {
          userHasSastProjectCreatePermission = response.allowed
        })
        .catch(function () {
          userHasSastProjectCreatePermission = false
        })
    }

    function setRbacAttackEventsViewPermission() {
      var rbacStatus = FeaturesService.getRbacStatus()
      const orgId = $routeParams.orgUuid
      const userId = ProfileService.getId()
      const flagPROD2300 = FeaturesService.isSplitFeatureFlagOn(
        'PROD-2300_attacks_grid_ui'
      )

      // checking for userId prevents making the call too early when the user isn't yet loaded
      if (!flagPROD2300 || !orgId || !userId || !rbacStatus.enabled) {
        userHasRbacAttackEventsViewPermission = false
        return
      }

      const getUserResourceGroupsByAction =
        ProfileFactory.getResourceGroupsByAction(orgId, 'VIEW_ATTACK_DATA')
          .then(function (response) {
            return {
              allowed:
                Array.isArray(response.data.accessList) &&
                response.data.accessList.length > 0
            }
          })
          .catch(function (err) {
            ErrorService.processError(err)
            return {
              allowed: false
            }
          })
      getUserResourceGroupsByAction
        .then(function (response) {
          userHasRbacAttackEventsViewPermission = response.allowed
        })
        .catch(function (err) {
          userHasRbacAttackEventsViewPermission = false
        })
    }

    function isAttackEventsViewEnabled() {
      return (
        UserService.isOrganizationProtectionEnabled() && // org level
        userHasRbacAttackEventsViewPermission // user level
      )
    }

    function setRbacManagePermission() {
      const orgId = $routeParams.orgUuid
      const userId = ProfileService.getId()

      // checking for userId prevents making the call too early when the user isn't yet loaded
      if (!orgId || !userId) {
        userHasRbacManagePermission = false
        return
      }

      const getUserResourceGroupsByAction =
        ProfileFactory.getResourceGroupsByAction(orgId, 'PLATFORM_ORG_MANAGE')
          .then(function (response) {
            return {
              allowed:
                Array.isArray(response.data.accessList) &&
                response.data.accessList.length > 0
            }
          })
          .catch(function (err) {
            ErrorService.processError(err)
            return {
              allowed: false
            }
          })
      getUserResourceGroupsByAction
        .then(function (response) {
          userHasRbacManagePermission = response.allowed
        })
        .catch(function (err) {
          userHasRbacManagePermission = false
        })
    }

    function hasRbacManagePermission() {
      return (
        userHasRbacManagePermission ||
        hasResourcePermission('USER_ACCESS_GROUP', 'PLATFORM_ORG_MANAGE')
      )
    }
  }
})()
